import { fetchService } from "./fetchService";
import * as API_PATHS from "utility/api-paths";
import { CatalogItem } from "utility/constants";

interface CloudServiceRequest {
  v_tdsp_point_of_contact: string;
  v_tdsp_description: string;
  v_business_justification: string;
  v_tdsp_pod_needed: { [key: string]: string };
  v_form_data: string;
}

export const fetchCloudProvisioningServices = async (): Promise<
  CatalogItem[]
> => {
  try {
    return await fetchService<CatalogItem[]>(API_PATHS.GET_CLOUD_SERVICES, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "An unknown error occurred."
    );
  }
};

export const fetchCloudServiceForm = async (
  serviceName: string
): Promise<any> => {
  try {
    const response = await fetchService<any>(
      API_PATHS.GET_CLOUD_SERVICE_FORM(serviceName),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return {
      form_schema: response.form_schema || {},
      ui_schema: response.ui_schema || {},
    };
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "An unknown error occurred."
    );
  }
};

export const submitCloudServiceRequest = async (
  cloudServiceData: CloudServiceRequest
): Promise<string> => {
  try {
    const response = await fetchService<any>(
      API_PATHS.SUBMIT_CLOUD_SERVICE_REQUEST,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: cloudServiceData,
      }
    );
    return response.result.request_number;
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "An unknown error occurred."
    );
  }
};
